import BootCheckbox from "components/common/custom/forms/BootCheckbox";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import MultiSelect from "components/common/MultiSelect";
import { GetAllPoyer } from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";
import React, { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { handlePriceFilter } from "../config/PriceSlice";

const PriceListFilters = ({ watch, control, setValue }) => {
  const dispatch = useDispatch();
  const { priceFilters } = useSelector((state) => state.price);
  const { poyerList } = useSelector((state) => state.eligibilityCheckList);
  const { userData } = useSelector((state) => state.auth);
  const { allPermissionType } = useSelector((state) => state.role);
  const branchSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Branch"
  );

  const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];
  useEffect(() => {
    if (poyerList?.length === 0) {
      dispatch(GetAllPoyer());
    }
  }, [poyerList]);

  useEffect(() => {
    setValue("payer", priceFilters?.payer);
    setValue("branch", priceFilters?.branch);
    setValue("nphies_code", priceFilters?.nphies_code);
    setValue("provider_code", priceFilters?.provider_code);
    setValue("is_active", priceFilters?.is_active);
  }, []);

  const handleBranch = (selected) => {
    if (!selected) {
      setValue("branch", null);
      dispatch(
        handlePriceFilter({
          check: "branch",
          value: null,
        })
      );
      return;
    }

    const value = {
      branch_name: selected.label,
      branch_id: selected.value,
    };
    setValue("branch", value);
    dispatch(handlePriceFilter({ check: "branch", value }));
  };

  const handlePayer = (selected) => {
    if (!selected) {
      setValue("payer", null);
      dispatch(
        handlePriceFilter({
          check: "payer",
          value: null,
        })
      );
      return;
    }

    const value = {
      payer_name: selected.label,
      payer_id: selected.value,
    };
    setValue("payer", value);
    dispatch(handlePriceFilter({ check: "payer", value }));
  };
  const handleNphiesCode = (value) => {
    setValue("nphies_code", value);
    dispatch(
      handlePriceFilter({
        check: "nphies_code",
        value,
      })
    );
  };
  const handleProviderCode = (value) => {
    setValue("provider_code", value);
    dispatch(
      handlePriceFilter({
        check: "provider_code",
        value,
      })
    );
  };
  const handleActive = (value) => {
    setValue("is_active", value);
    dispatch(
      handlePriceFilter({
        check: "active",
        value,
      })
    );
  };

  return (
    <Row alignItems="center">
      {Number(branchSetting?.list) === 1 && (
        <Col xs={12} sm={6} md={3} xl={2}>
          <label className="form-label">Branch</label>
          <Controller
            name="branch"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={allBranches?.map((item) => ({
                  value: item.branch_id,
                  label: item.branch_name,
                }))}
                isClearable={true}
                value={
                  field.value
                    ? {
                      value: field.value.branch_id,
                      label: field.value.branch_name,
                    }
                    : null
                }
                onChange={(selected) => handleBranch(selected)}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      )}
      <Col xs={12} sm={6} md={3} xl={2}>
        <label className="form-label">Payer</label>
        <Controller
          name="payer"
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect={false}
              isMulti={false}
              options={poyerList?.map((item) => ({
                value: item.payer_id,
                label: item.payer_name,
              }))}
              isClearable={true}
              value={
                field.value
                  ? {
                    value: field.value.payer_id,
                    label: field.value.payer_name,
                  }
                  : null
              }
              onChange={(selected) => handlePayer(selected)}
              formatOptionLabel={({ label }) => <div>{label}</div>}
              getOptionValue={(option) => option.value}
              placeholder="Choose ..."
            />
          )}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="nphies_code"
          label="Nphies Service Code"
          placeholder="Nphies Service Code"
          control={control}
          onChange={(selected) => handleNphiesCode(selected)}
          required={false}
          size="sm"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="provider_code"
          label="Provider Service Code"
          placeholder="Provider Service Code"
          onChange={(selected) => handleProviderCode(selected)}
          required={false}
          control={control}
          size="sm"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <BootCheckbox
          name="is_active"
          label="Exclude Deactivated Service ?"
          required={false}
          changehandler={(selected) => handleActive(selected)}
          control={control}
          className="d-flex justify-content-center"
        />
      </Col>
    </Row>
  );
};

export default PriceListFilters;
